import { DialogWrapper } from "./component";

export { useDialogContext } from "./DialogWrapperContext";

export default DialogWrapper;
